import AOS from 'aos'
import './navigation.js'

window.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 800,
		once: true,
		disable: 'mobile',
		offset: 30,
	})

	setTimeout(() => {
		AOS.refresh()
	}, 100)
})
